//@flow

import React from 'react';
import i18n from 'app/common/lib/i18n';
import PrettyNumber from 'app/common/react/i18n/PrettyNumber';
import { interpolateNamedTemplate } from 'app/common/lib/react/interpolate';

export default function makeRecipeTimeText({
  m: minutes,
  h: hours,
  rm: roundedMins,
  rh: roundedHrs,
}: {
  h: number,
  m: number,
  rh: number,
  rm: number,
}) {
  if (!!minutes && (!hours || roundedHrs <= 0)) {
    return interpolateNamedTemplate(
      i18n.ngettext('{{mins}} minute', '{{mins}} minutes', roundedMins),
      {
        mins: <PrettyNumber key="recipe-minutes" maximumFractionDigits={2} value={roundedMins} />,
      },
    );
  }

  if (hours) {
    return interpolateNamedTemplate(i18n.ngettext('{{hrs}} hour', '{{hrs}} hours', roundedHrs), {
      hrs: <PrettyNumber key="recipe-hours" maximumFractionDigits={2} value={roundedHrs} />,
    });
  }

  return null;
}
